import { css, cx } from "@emotion/css";
import { borderRadius, fontWeight, space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import cn from "classnames";
import React from "react";
import { ProjectStatusIcon } from "../../ProjectStatus/ProjectStatusIcon";
interface ConfigWizardStatusProps {
    activeStage: ConfigWizardStages;
    isCommittingRunbooksToNewBranch: boolean;
}
type ConfigWizardStages = "Environment" | "Naming" | "Provisioning" | "Deprovisioning" | "Branch";
type TaskState = "Current" | "Pending" | "Done";
export const ConfigWizardStatusBar = ({ activeStage, isCommittingRunbooksToNewBranch }: ConfigWizardStatusProps): JSX.Element | null => {
    const styles = {
        wrapper: css({
            overflowX: "auto",
            background: themeTokens.color.background.secondary.default,
            borderRadius: borderRadius.small,
        }),
        container: css({
            font: text.body.regular.xSmall,
            fontSize: "0.75rem",
            display: "flex",
            gap: isCommittingRunbooksToNewBranch ? space[4] : space[8],
            alignItems: "center",
            justifyContent: "start",
            padding: `${space[8]} ${space[12]}`,
            userSelect: "none",
        }),
    };
    const stages: ConfigWizardStages[] = ["Environment", "Naming", "Provisioning", "Deprovisioning"];
    if (isCommittingRunbooksToNewBranch) {
        stages.push("Branch");
    }
    const indexOfActiveStage = stages.indexOf(activeStage);
    return (<div className={styles.wrapper}>
            <div className={cx(styles.container)}>
                {stages.map((stage, index) => {
            return <WizardStatusBarStage name={stage} state={getItemState(index, indexOfActiveStage)} isCommittingRunbooksToNewBranch={isCommittingRunbooksToNewBranch}/>;
        })}
            </div>
        </div>);
};
function getItemState(index: number, activeItem: number): TaskState {
    if (index < activeItem)
        return "Done";
    if (index > activeItem)
        return "Pending";
    return "Current";
}
interface WizardStatusBarStageProps {
    name: string;
    state: TaskState;
    isCommittingRunbooksToNewBranch: boolean;
}
export const WizardStatusBarStage = ({ name, state, isCommittingRunbooksToNewBranch }: WizardStatusBarStageProps): JSX.Element => {
    const stageStyles = {
        statusItemContainer: css({
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            gap: isCommittingRunbooksToNewBranch ? space[4] : space[8],
            borderRadius: borderRadius.small,
            whiteSpace: "nowrap",
            color: themeTokens.color.text.tertiary,
            padding: isCommittingRunbooksToNewBranch ? `${space[4]} ${space[4]}` : `${space[4]} ${space[8]}`,
        }),
        active: css({
            background: themeTokens.color.background.primary.default,
            fontWeight: fontWeight[500],
            "&&": {
                color: themeTokens.color.text.primary,
            },
        }),
        complete: css({
            "&&": {
                color: themeTokens.color.text.primary,
            },
        }),
    };
    if (state === "Current") {
        return (<div className={cn(stageStyles.statusItemContainer, stageStyles.active)}>
                <ProjectStatusIcon state={state}/>
                <span>{name}</span>
            </div>);
    }
    return (<div className={cn(stageStyles.statusItemContainer, { [stageStyles.complete]: state === "Done" })}>
            <ProjectStatusIcon state={state}/>
            <span>{name}</span>
        </div>);
};
